import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e82819b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "mark" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd" }, "Sales Revenue", -1))
const _hoisted_4 = { class: "revenue" }
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subhd" }, "Products", -1))
const _hoisted_8 = { class: "products" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "count" }
const _hoisted_11 = {
  key: 0,
  class: "bottom"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subhd" }, "Connect Bundled Nodes", -1))
const _hoisted_13 = { class: "products" }
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_svg = _resolveComponent("ui-svg")!
  const _component_ui_icon_button = _resolveComponent("ui-icon-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "accounting-brand-summary-card",
    style: _normalizeStyle(_ctx.cardStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ui_svg, { src: _ctx.logoMark }, null, 8, ["src"])
      ]),
      (_ctx.card.ready)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDollar(_ctx.card.totalRevenueUsd_string)), 1),
              _createElementVNode("div", {
                class: "swap",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.swapCurrency($event)))
              }, [
                _createVNode(_component_ui_icon_button, { icon: "switch" })
              ])
            ]),
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.products, (product) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: product.id,
                  class: "product"
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(product.name), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(product.quantitySold), 1)
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.card.ready && _ctx.card.bundledProducts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.bundledProducts, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.id,
                class: "product"
              }, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(product.name), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(product.quantitySold), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}